import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, Mail, Send } from "lucide-react";

// Box discreto di iscrizione per testate/media: lascia email (+ nome media opzionale)
// per ricevere i nuovi comunicati. Salva in Admin (lounge_press_subscribers).
export function PressSubscribeBox({ c, refValue, lang }) {
  const [email, setEmail] = useState("");
  const [outlet, setOutlet] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return toast.error(c.sub_err_email);
    setBusy(true);
    try {
      const { data } = await api.post("/public/lounge/press-subscribe", { email: email.trim(), outlet: outlet.trim(), ref: refValue || "", lang: lang || "it" });
      toast.success(data?.confirmed ? c.sub_already : c.sub_check_email);
      setEmail(""); setOutlet("");
    } catch {
      toast.error(c.sub_err_email);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="mx-auto max-w-6xl px-5 pt-4 sm:px-8" data-testid="press-subscribe">
      <div className="rounded-2xl border border-border bg-card p-5 sm:p-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-3">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand/15 text-brand">
              <Mail className="h-4 w-4" />
            </span>
            <div>
              <h3 className="text-sm font-bold text-foreground" data-testid="press-subscribe-title">{c.sub_title}</h3>
              <p className="text-sm text-muted-foreground">{c.sub_desc}</p>
            </div>
          </div>
          <form onSubmit={submit} className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center" data-testid="press-subscribe-form">
            <Input
              value={outlet}
              onChange={(e) => setOutlet(e.target.value)}
              placeholder={c.sub_outlet_ph}
              className="sm:w-52"
              data-testid="press-subscribe-outlet"
            />
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={c.sub_email_ph}
              className="sm:w-56"
              data-testid="press-subscribe-email"
            />
            <Button type="submit" disabled={busy} className="rounded-full bg-primary font-semibold text-primary-foreground hover:bg-primary/90" data-testid="press-subscribe-submit">
              {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Send className="mr-1.5 h-4 w-4" />}
              {c.sub_btn}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
}
